import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";

export const DocumentRenderer = () => {
  const { country, documentName, folderName } = useParams();
  const location = useLocation();
  const [documentPath, setDocumentPath] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Handle special route patterns
    const pathSegments = location.pathname.split('/').filter(segment => segment);

    // Check for /healthx/customer-journey pattern (case-insensitive)
    if (pathSegments.length === 2 && pathSegments[0].toLowerCase() === 'healthx' && pathSegments[1].toLowerCase() === 'customer-journey') {
      setDocumentPath('/Documents/Ke/HealthX/Customer-Journey.html');
      setLoading(false);
      return;
    }

    // Check for /healthx/terms pattern (case-insensitive)
    if (pathSegments.length === 2 && pathSegments[0].toLowerCase() === 'healthx' && pathSegments[1].toLowerCase() === 'terms') {
      setDocumentPath('/Documents/Ke/HealthX/TermsConditions.html');
      setLoading(false);
      return;
    }

    // Clean up document name (remove .pdf extension if present)
    const cleanDocName = documentName
      ? documentName.replace(/\.pdf$/, "").toLowerCase()
      : location.pathname
          .split("/")
          .pop()
          .replace(/\.pdf$/, "")
          .toLowerCase();

    // Document mapping to handle special cases and organization
    const documentDirectoryMap = {
      // Format: 'documentName': { country: 'countryCode', folder: 'folderName', file: 'fileName.html' }
      britam: { country: "Ke", folder: "Britam", file: "britam.html" },
      britamtz: { country: "Tz", folder: "Britam", file: "britamtz.html" },
      "personal-accident": {
        country: "Ke",
        folder: "Britam",
        file: "Personal-Accident.html",
      },
      "pa-lifecover": {
        country: "Ke",
        folder: "Absa",
        file: "Britam-Absa.html",
      },
      "mfanisi": {
        country: "Ke",
        folder: "Maishapoa",
        file: "MfanisiGoTnc.html",
      },
      "customer-journey": {
        country: "Ke",
        folder: "HealthX",
        file: "Customer-Journey.html",
      },
      "terms": {
        country: "Ke",
        folder: "HealthX",
        file: "TermsConditions.html",
      },
      // Add other document mappings here as you create them
    };

    let path;

    // Handle different route patterns
    if (location.pathname.startsWith("/documents/")) {
      // Direct document path
      path = `/Documents${location.pathname.substring(10)}`;
    } else if (country && folderName && documentName) {
      // Country/folder/document pattern
      const normalizedDocName = documentName
        .toLowerCase()
        .replace(/\.pdf$/, "");
      const formattedCountry =
        country.charAt(0).toUpperCase() + country.slice(1);
      const formattedFolder =
        folderName.charAt(0).toUpperCase() + folderName.slice(1);

      // Handle special case for Personal-Accident (with capital P and A)
      if (normalizedDocName === "personal-accident") {
        path = `/Documents/${formattedCountry}/${formattedFolder}/Personal-Accident.html`;
      } else {
        path = `/Documents/${formattedCountry}/${formattedFolder}/${normalizedDocName}.html`;
      }
    } else if (country && documentName) {
      // Country/document pattern - Handle special cases
      const normalizedCountry = country.toLowerCase();

      // Check if we have a mapping for this document
      if (documentDirectoryMap[cleanDocName]) {
        const docInfo = documentDirectoryMap[cleanDocName];

        // If country is specified in URL, use that country's version if available
        if (normalizedCountry === "tz" && cleanDocName === "britam") {
          path = `/Documents/Tz/Britam/britamtz.html`;
        } else {
          path = `/Documents/${docInfo.country}/${docInfo.folder}/${docInfo.file}`;
        }
      }
      // Intelligent document path resolution for non-explicitly mapped documents
      else {
        // Capitalize first letter of country for folder structure
        const formattedCountry =
          country.charAt(0).toUpperCase() + country.slice(1).toLowerCase();

        // Try known folder structures
        const possiblePaths = [
          `/Documents/${formattedCountry}/${cleanDocName}.html`,
          `/Documents/${formattedCountry}/${cleanDocName}/${cleanDocName}.html`,
          `/Documents/${formattedCountry}/${
            cleanDocName.charAt(0).toUpperCase() + cleanDocName.slice(1)
          }/${cleanDocName}.html`,
        ];

        // For simplicity we'll use the first path for now
        // In a more complete implementation, you could check for file existence
        path = possiblePaths[0];
      }
    } else {
      // Direct document name without country - fallback
      if (documentDirectoryMap[cleanDocName]) {
        const docInfo = documentDirectoryMap[cleanDocName];
        path = `/Documents/${docInfo.country}/${docInfo.folder}/${docInfo.file}`;
      } else {
        path = `/Documents/${cleanDocName}.html`;
      }
    }

    console.log("Document path:", path); // Debug output
    setDocumentPath(path);
    setLoading(false);
  }, [country, documentName, folderName, location.pathname]);

  if (loading) {
    return <div>Loading document...</div>;
  }

  if (error) {
    return <div>Error loading document: {error}</div>;
  }

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <iframe
        src={documentPath}
        title={documentName || "Document"}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        allowFullScreen
      />
    </div>
  );
};
